export default {
    name: "tabs-switch",
    components: {},
    props: ["tabs", "selectedTab"],
    data() {
        return {};
    },
    computed: {},
    mounted() {},
    methods: {},
};
